export default "__VITE_ASSET__eff695b3__"